import { Box, Typography, useTheme } from '@mui/material';
import { scaledFontSize } from '../createWidgetTheme';

interface BotMessageHeadingProps {
  agentName: string;
}

/** Each assistant bubble exposes the agent name as h4 for heading navigation. */
export function BotMessageHeading({ agentName }: BotMessageHeadingProps) {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" gap={0.75} mb={0.25}>
      <Box
        sx={{
          width: 4,
          height: 4,
          borderRadius: '50%',
          bgcolor: theme.palette.info.main,
        }}
      />
      <Typography
        component="h4"
        variant="caption"
        fontSize={scaledFontSize(theme, 12)}
        sx={{ fontWeight: 400, m: 0 }}
        color="textDisabled"
      >
        {agentName.toUpperCase()}
      </Typography>
    </Box>
  );
}
